import { render, staticRenderFns } from "./SellerItem.vue?vue&type=template&id=5914b8ac"
import script from "./SellerItem.vue?vue&type=script&lang=js"
export * from "./SellerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports